
import Component from '../../../assets/scripts/modules/component'

class TextFieldComponent extends Component {
  init () {
    this.input = this.element.querySelector('.text-field__input')

    if (!this.input) {
      return
    }

    if (this.input.getAttribute('type') === 'number') {
      this.input.addEventListener('keyup', () => this.forceIntegerValuesOnly())
    }

    this.input.addEventListener('change', () => this.element.classList.toggle('text-field--empty', !this.input.value.length))
    this.input.addEventListener('focus', () => this.element.classList.add('text-field--focussed'))
    this.input.addEventListener('blur', () => this.element.classList.remove('text-field--focussed'))

    this.checkEmptyness()

    window.setTimeout(() => {
      this.element.classList.add('text-field--fancy-labels')
    }, 150) // Prevent initial transition
  }

  checkEmptyness () {
    this.element.classList.toggle('text-field--empty', !this.input.value.length)
  }

  forceIntegerValuesOnly () {
    if (!Number.isInteger(parseInt(this.input.value, 10))) {
      this.input.value = null

      window.requestAnimationFrame(() => {
        this.input.value = ''
      })
    }
  }
}

window.addEventListener('init-load', () => document.querySelectorAll('.text-field').forEach(element => {
  element.instance = element.instance || new TextFieldComponent(element)
}))
